import z from 'zod'

export const ExclusionZoneFormSchema = z.object({
	name: z.string().min(1),
	description: z.string().min(1),
	monitoredAreaId: z.uuid(),
})
